"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSTimeOffSection = void 0;
const ui_1 = require("@app/component/ui");
const dropdown_input_1 = require("@app/component/ui/forms/dropdown-input/dropdown-input");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const time_input_1 = require("@app/component/ui/forms/time-input/time-input");
const graphql_1 = require("@app/gql-types/graphql");
const util_1 = require("@app/util");
const use_calendar_settings_1 = require("@app/util/use-calendar-settings");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const calendar_settings_context_1 = require("../../../calendar-settings-context");
const process_options_1 = require("../../../util/process-options");
const _timeOffShowTimeDataAsOptions = [
    {
        value: use_calendar_settings_1.TimeOffShowTimeDataAs.Period,
        label: 'START_AND_END',
    },
    {
        value: use_calendar_settings_1.TimeOffShowTimeDataAs.Duration,
        label: 'CUSTOM_ATTRIBUTE_TYPE.duration',
    },
];
const _timeOffShowAtBottomOptions = [
    {
        value: use_calendar_settings_1.TimeOffShowAtBottom.Shortcut,
        label: 'SHORT',
    },
    {
        value: use_calendar_settings_1.TimeOffShowAtBottom.Name,
        label: 'NAME_V2',
    },
    {
        value: use_calendar_settings_1.TimeOffShowAtBottom.Nothing,
        label: 'NOTHING',
    },
];
const _timeOffDefaultInclusion = [
    {
        value: graphql_1.TimeOffWorkMinutesInclusion.EveryDay,
        label: 'EVERY_DAY',
    },
    {
        value: graphql_1.TimeOffWorkMinutesInclusion.WorkDays,
        label: 'WORK_DAYS',
    },
    {
        value: graphql_1.TimeOffWorkMinutesInclusion.ShiftDays,
        label: 'SHIFT_DAYS',
    },
];
const _timeOffWorkMinutesByOptions = [
    {
        value: graphql_1.TimeOffWorkMinutesBy.Shift,
        label: 'BY_REPLACED_SHIFT',
    },
    {
        value: graphql_1.TimeOffWorkMinutesBy.Contract,
        label: 'BY_CONTRACT',
    },
    {
        value: graphql_1.TimeOffWorkMinutesBy.Custom,
        label: 'CUSTOM',
    },
];
const CSTimeOffSection = () => {
    const timeOffShowTimeDataAsOptions = react_1.default.useRef((0, process_options_1.processOptions)(_timeOffShowTimeDataAsOptions));
    const timeOffShowAtBottomOptions = react_1.default.useRef((0, process_options_1.processOptions)(_timeOffShowAtBottomOptions));
    const timeOffDefaultInclusion = react_1.default.useRef((0, process_options_1.processOptions)(_timeOffDefaultInclusion));
    const timeOffWorkMinutesByOptions = react_1.default.useRef((0, process_options_1.processOptions)(_timeOffWorkMinutesByOptions));
    const { control } = (0, calendar_settings_context_1.useCalendarSettingsContext)();
    const timeOffWorkMinutesBy = (0, react_hook_form_1.useWatch)({ control, name: 'timeOffWorkMinutesBy' });
    return (react_1.default.createElement("div", { style: { padding: '0.75rem' } },
        react_1.default.createElement("div", { style: {
                width: '50%',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                paddingBottom: '0.75rem',
                boxSizing: 'border-box',
            } },
            react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('CALENDAR_SETTINGS_TIMEOFF_SECTION_TITLE')),
            react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_4, type: ui_1.Spacing.TYPES.HORIZONTAL }),
            react_1.default.createElement(dropdown_input_1.DropdownInput, { control: control, name: 'timeOffShowTimeDataAs', label: (0, util_1.t)('SHOW_TIME_DATA_AS'), options: timeOffShowTimeDataAsOptions.current, sortedOptions: false }),
            react_1.default.createElement(dropdown_input_1.DropdownInput, { control: control, name: 'timeOffShowAtBottom', label: (0, util_1.t)('SHOW_AT_BOTTOM'), options: timeOffShowAtBottomOptions.current, sortedOptions: false })),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                paddingBottom: '0.75rem',
                boxSizing: 'border-box',
            } },
            react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('CALENDAR_SETTINGS_TIMEOFF_DEFAULT_INCLUSION_TITLE')),
            react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_4, type: ui_1.Spacing.TYPES.HORIZONTAL }),
            react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
                react_1.default.createElement(dropdown_input_1.DropdownInput, { control: control, name: 'timeOffDefaultInclusion', label: (0, util_1.t)('UNAV_WORK_MINUTES_INCLUSION'), options: timeOffDefaultInclusion.current, sortedOptions: false }),
                react_1.default.createElement("div", null),
                react_1.default.createElement(dropdown_input_1.DropdownInput, { control: control, name: 'timeOffWorkMinutesBy', label: (0, util_1.t)('INCLUDE'), options: timeOffWorkMinutesByOptions.current, sortedOptions: false }),
                timeOffWorkMinutesBy === graphql_1.TimeOffWorkMinutesBy.Custom ? (react_1.default.createElement(time_input_1.TimeInput, { name: 'timeOffCustomInclusion', label: (0, util_1.t)('VALUE'), control: control })) : null))));
};
exports.CSTimeOffSection = CSTimeOffSection;
